import React from "react";
import { getImageURL } from "../../utils/imageUrl";
import dummy from "../../assets/images/profile.png";
import { Image } from "primereact/image";

export default function TableImage({ image, classsName }) {
    return (
        <Image
            src={image ? getImageURL(image) : dummy}
            onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = dummy;
            }}
            alt={image}
            className={classsName}
            width="35"
            height="35"
            preview
        />
    );
}
